import { HTMLAttributes } from 'react';
import {
  NotificationCountStyleVariants,
  notificationCountStyles,
} from './variants';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../typography/typography';

type Props = {
  className?: string;
  count: number;
} & Omit<
  HTMLAttributes<HTMLDivElement>,
  'className' | 'children' | 'aria-live' | 'aria-atomic'
> &
  Omit<NotificationCountStyleVariants, 'size'>;

export function NotificationCount(props: Props) {
  const { className, intent = 'default', count, ...rest } = props;

  const MAXIMUM_NOTIFICATIONS = 999;

  const displayCount = count > MAXIMUM_NOTIFICATIONS ? '999+' : count;
  const size: NotificationCountStyleVariants['size'] =
    count > MAXIMUM_NOTIFICATIONS ? 'large' : 'small';

  return (
    <div
      className={twMerge(notificationCountStyles({ intent, size }), className)}
      role="status"
      aria-live={intent === 'new' ? 'assertive' : 'polite'}
      aria-atomic="true"
      {...rest}
    >
      <Typography
        as="span"
        variant="body-xxs"
        weight="semibold"
        className="text-currentColor leading-none"
      >
        {displayCount}
      </Typography>
    </div>
  );
}
